export default "/email-attendees-dashboard.d18cb10b-4308e8.png";